import React, { useEffect } from 'react';
import { ConnectAccountResponse } from '../types';

interface ConnectSuccessProps {
  connectResult: ConnectAccountResponse;
  onGoToMain: () => void;
}

const ConnectSuccess: React.FC<ConnectSuccessProps> = ({ connectResult, onGoToMain }) => {
  const { result } = connectResult;
  
  useEffect(() => {
    if (window.opener || window.parent !== window) {
      const message = {
        type: 'CONNECT_SUCCESS',
        data: {
          status: result.status,
          uid: connectResult.uid,
          provider: result.provider,
          message: result.status === 'merged' 
            ? 'Аккаунты успешно объединены' 
            : 'Аккаунт успешно подключен'
        }
      };
      
      if (window.opener) {
        window.opener.postMessage(message, '*');
      }
      
      if (window.parent !== window) {
        window.parent.postMessage(message, '*');
      }
    }
  }, [connectResult, result]);
  
  return (
    <div className="flex flex-col min-h-screen bg-zinc-900">
      {/* Content */}
      <div className="flex flex-col flex-1 justify-center px-6 py-8">
        {/* Success icon */}
        <div className="flex justify-center mb-6">
          <div className="flex justify-center items-center w-16 h-16 rounded-2xl bg-emerald-500/20">
            <svg className="w-8 h-8 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>
        
        <h2 className="mb-2 text-xl font-semibold text-center text-white">
          {result.status === 'merged' ? 'Аккаунты объединены' : 'Аккаунт подключен'}
        </h2>
        
        <p className="mb-6 text-sm text-center text-zinc-400">
          {result.status === 'merged' 
            ? 'Единая система входа активирована'
            : `${result.provider === 'telegram' ? 'Telegram' : 'VK'} подключен`
          }
        </p>

        {/* Info */}
        <div className="p-4 mb-6 space-y-3 rounded-xl border bg-zinc-900 border-zinc-800">
          <div className="flex justify-between items-center">
            <span className="text-xs text-zinc-500">Провайдер</span>
            <span className="text-sm text-zinc-300">
              {result.provider === 'telegram' ? 'Telegram' : 'VK'}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-xs text-zinc-500">Статус</span>
            <span className={`text-sm ${
              result.status === 'merged' ? 'text-purple-400' : 'text-emerald-400'
            }`}>
              {result.status === 'merged' ? 'Объединены' : 'Добавлен'}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-xs text-zinc-500">ID</span>
            <span className="font-mono text-sm text-zinc-300">{result.unique}</span>
          </div>
        </div>

        {/* Go to main button */}
        <button
          onClick={onGoToMain}
          className="w-full flex items-center justify-center px-4 py-3.5 rounded-xl bg-[#0077FF]/10 border border-[#0077FF]/30 text-[#0077FF] font-medium hover:bg-[#0077FF]/20 transition-colors"
        >
          <svg className="mr-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          <span>На главную</span>
        </button>

        {/* Info note */}
        <div className="p-3 mt-4 rounded-xl border bg-zinc-900 border-zinc-800">
          <p className="text-xs text-center text-zinc-500">
            {result.status === 'merged' 
              ? 'Теперь можно входить через любой способ'
              : 'Добавлен новый способ входа'
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConnectSuccess;
